module.exports = __webpack_public_path__ + "static/img/chain-contract-num.6b0ba4e2.png";